module.exports = __webpack_public_path__ + "static/hyperv_27.fd388724.jpg";